import axios, { type AxiosInstance } from "axios";

/**
 * Anonymous axios instance — deliberately carries NO Authorization header
 * so unauthenticated endpoints (login, OTP, password reset) can never leak
 * the user's bearer token (PLX §6).
 *
 * `withCredentials: true` so the PayGate auth session cookie (JSESSIONID)
 * set on login is carried across the OTP send/validate steps.
 */
export const publicApiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

publicApiClient.interceptors.request.use((config) => {
  if (config.data && !(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});
